import { Button, CreatableSelectDropDown, SelectDropDown } from '@wot/components';
import { useEffect, useState } from 'react';
import { CLOSE_ICON } from '../../../../assets/icons';
import ProfileIssues from '../../ProfileIssues';
import { ITutorEducation, ITutorEducationDetails } from '@wot/typings';
import { LOADING } from '../../../../assets/animated';
import UNIVERSITIES from '../../../../utils/universties.json';

const degreeOptions = ['High School', 'Diploma', 'Bachelor’s', 'Master’s', 'PHD'];

const courseCategories: Record<string, string[]> = {
  'High School': [
    "High School"
  ],
  Diploma: [
    'Accounting',
    'Biotechnology',
    'Business Administration',
    'Cybersecurity',
    'Design',
    'Fashion Design',
    'Graphic Design',
    'Hospitality Management',
    'Information Technology',
    'Marketing',
    'Nursing',
    'Tourism Management'
  ],
  'Bachelor’s': [
    'Accounting',
    'Aerospace Engineering',
    'Agricultural Science',
    'Anthropology',
    'Archaeology',
    'Architecture',
    'Art History',
    'Artificial Intelligence',
    'Astrophysics',
    'Bachelor of Arts',
    'Bachelor of Science',
    'Biochemistry',
    'Biology',
    'Biomedical Engineering',
    'Biotechnology',
    'Business Administration',
    'Business Analyst',
    'Chemical Engineering',
    'Chemistry',
    'Civil Engineering',
    'Cognitive Science',
    'Communication Studies',
    'Computer Engineering',
    'Computer Science',
    'Criminology',
    'Cybersecurity',
    'Data Science',
    'Dentistry',
    'Design',
    'Drama',
    'Earth Sciences',
    'Economics',
    'Education',
    'Electrical Engineering',
    'English Literature',
    'Environmental Science',
    'Fashion Design',
    'Film Studies',
    'Finance',
    'Fine Arts',
    'Food Science',
    'Forensic Science',
    'Genetics',
    'Geography',
    'Geology',
    'Graphic Design',
    'History',
    'Hospitality Management',
    'Human Resource Management',
    'Industrial Engineering',
    'Information Technology',
    'International Relations',
    'Journalism',
    'Law',
    'Linguistics',
    'Management',
    'Marketing',
    'Materials Science',
    'Mathematics',
    'Mechanical Engineering',
    'Mechatronics',
    'Media Studies',
    'Medicine',
    'Microbiology',
    'Music',
    'Neuroscience',
    'Nursing',
    'Nutrition',
    'Oceanography',
    'Pharmacy',
    'Philosophy',
    'Physics',
    'Political Science',
    'Psychology',
    'Robotics',
    'Social Work',
    'Sociology',
    'Software Engineering',
    'Sports Science',
    'Statistics',
    'Supply Chain Management',
    'Theatre Arts',
    'Theology',
    'Tourism Management',
    'Veterinary Medicine',
    'Zoology'
  ],
  'Master’s': [
    'Accounting',
    'Aerospace Engineering',
    'Agricultural Science',
    'Anthropology',
    'Archaeology',
    'Architecture',
    'Art History',
    'Artificial Intelligence',
    'Astrophysics',
    'Biochemistry',
    'Biology',
    'Biomedical Engineering',
    'Biotechnology',
    'Business Administration',
    'Business Analyst',
    'Chemical Engineering',
    'Chemistry',
    'Civil Engineering',
    'Cognitive Science',
    'Communication Studies',
    'Computer Engineering',
    'Computer Science',
    'Criminology',
    'Cybersecurity',
    'Data Science',
    'Design',
    'Drama',
    'Earth Sciences',
    'Economics',
    'Education',
    'Electrical Engineering',
    'English Literature',
    'Environmental Science',
    'Film Studies',
    'Finance',
    'Fine Arts',
    'Food Science',
    'Forensic Science',
    'Genetics',
    'Geography',
    'Geology',
    'Graphic Design',
    'History',
    'Hospitality Management',
    'Human Resource Management',
    'Industrial Engineering',
    'Information Technology',
    'International Relations',
    'Journalism',
    'Law',
    'Linguistics',
    'Management',
    'Marketing',
    'Master of Arts',
    'Master of Science',
    'Materials Science',
    'Mathematics',
    'Mechanical Engineering',
    'Mechatronics',
    'Media Studies',
    'Microbiology',
    'Music',
    'Neuroscience',
    'Nursing',
    'Nutrition',
    'Oceanography',
    'Philosophy',
    'Physics',
    'Political Science',
    'Psychology',
    'Public Health',
    'Robotics',
    'Social Work',
    'Sociology',
    'Software Engineering',
    'Sports Science',
    'Statistics',
    'Supply Chain Management',
    'Sustainable Development',
    'Theatre Arts',
    'Theology',
    'Tourism Management',
    'Urban Planning',
    'Zoology'
  ],
  PHD: [
    'Aerospace Engineering',
    'Anthropology',
    'Archaeology',
    'Artificial Intelligence',
    'Astrophysics',
    'Biochemistry',
    'Biology',
    'Biomedical Engineering',
    'Chemical Engineering',
    'Chemistry',
    'Civil Engineering',
    'Cognitive Science',
    'Computer Engineering',
    'Computer Science',
    'Data Science',
    'Doctor of Philosophy',
    'Earth Sciences',
    'Economics',
    'Electrical Engineering',
    'Environmental Science',
    'Genetics',
    'Geography',
    'Geology',
    'History',
    'Industrial Engineering',
    'Linguistics',
    'Materials Science',
    'Mathematics',
    'Mechanical Engineering',
    'Mechatronics',
    'Microbiology',
    'Neuroscience',
    'Oceanography',
    'Philosophy',
    'Physics',
    'Political Science',
    'Psychology',
    'Public Health',
    'Robotics',
    'Sociology',
    'Software Engineering',
    'Statistics',
    'Theology',
    'Zoology'
  ]
};



const year = new Date().getFullYear();
const years = Array.from(new Array(70), (val, index) => year - index);

interface Props {
  education?: ITutorEducationDetails;
  onSave?: (data: ITutorEducationDetails) => void;
  onSaveAndNext?: (data: ITutorEducationDetails) => void;
  loading?: boolean;
}

function EducationDetails({ education, onSave, onSaveAndNext, loading }: Props) {
  const [educationList, setEducationList] = useState<ITutorEducation[]>(education?.data || []);
  const onSubmit = () => {
    onSave &&
      onSave({
        data: educationList,
        status: education?.status === 'verified' ? education.status : 'pending',
        issues: []
      });
  };

  const onSubmitNext = () => {
    onSaveAndNext &&
      onSaveAndNext({
        data: educationList,
        status: education?.status === 'verified' ? education.status : 'pending',
        issues: []
      });
  };

  const handleFormChange = (newValues: ITutorEducation, index?: number, remove?: number) => {
    let temp = [...educationList];
    if (index) {
      if (remove) {
        temp = temp.filter((item, idx) => idx !== index - 1);
        setEducationList(temp);
        return;
      }
      temp[index - 1] = newValues;
      setEducationList(temp);
    } else {
      temp.push(newValues);
      setEducationList(temp);
    }
  };

  return (
    <div className="h-full flex flex-col overflow-hidden pb-20">
      {education?.status === 'issue' && education.issues.length > 0 && <ProfileIssues issues={education.issues} />}
      <div className="h-full w-full md:px-10 overflow-y-scroll custom-scrollbar">
        <CurrentForm handleFormChange={handleFormChange} />
        <div className="w-full flex flex-col gap-4 mb-4">
          {educationList.map((edu, index) => (
            <EducationItem education={edu} handleFormChange={handleFormChange} index={index + 1} key={index} />
          ))}
        </div>
      </div>
      {educationList.length > 0 && (
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full bg-white py-5 border-t">
          <div className="max-w-sm w-full mx-auto flex gap-4 items-center justify-center">
            {loading ? (
              <div className="w-full flex items-center justify-center">
                <img src={LOADING} className="w-10 h-10" />
              </div>
            ) : (
              <>
                <div className="w-full block md:max-w-[164px]">
                  <Button block text={'Save'} onClick={() => onSubmit()} />
                </div>
                {onSaveAndNext && (
                  <div className="w-full block md:max-w-[164px]">
                    <Button block text={'Save & Next'} onClick={() => onSubmitNext()} />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function CurrentForm({ handleFormChange }: { handleFormChange: (v: ITutorEducation, index?: number) => void }) {
  const [current, setCurrent] = useState<ITutorEducation>({
    degree: '',
    course: '',
    specialisation: '',
    year: 0,
    university: ''
  });

  const [errors, setErrors] = useState<EducationFormErrors>();
  const [showNewForm, setShowNewForm] = useState<boolean>(false);

  return (
    <div className="w-full flex flex-col my-5 gap-7">
      <div className="w-full flex items-center justify-between">
        <h1 className="text-xl font-semibold">Education Details</h1>
        <div className="max-w-xs">
          {!showNewForm && (
            <Button
              text="+ Add New"
              onClick={() => {
                setShowNewForm(true);
              }}
            />
          )}
        </div>
      </div>
      {showNewForm && (
        <div className="border border-gray-300 rounded-md p-4">
          <div className="flex gap-4 items-start">
            <EducationForm
              degree={current.degree}
              setDegree={(value) => setCurrent({ ...current, degree: value })}
              course={current.course}
              setCourse={(value) => setCurrent({ ...current, course: value })}
              specialisation={current.specialisation}
              setSpecialisation={(value) => setCurrent({ ...current, specialisation: value })}
              university={current.university}
              setUniversity={(value) => setCurrent({ ...current, university: value })}
              year={current.year}
              setYear={(value) => setCurrent({ ...current, year: value })}
              errors={errors}
            />
            <img
              src={CLOSE_ICON}
              className="w-4 cursor-pointer"
              onClick={() => {
                setShowNewForm(false);
                setCurrent({
                  degree: '',
                  course: '',
                  specialisation: '',
                  year: 0,
                  university: ''
                });
                setErrors({
                  degree: false,
                  course: false,
                  year: false,
                  university: false
                });
              }}
            />
          </div>
          <div className="w-32 mt-5">
            <Button
              block
              text="Add"
              onClick={() => {
                setShowNewForm(false);
                if (!current.degree || !current.course || !current.year || !current.university) {
                  setErrors({
                    ...errors,
                    degree: !current.degree,
                    course: !current.course,
                    university: !current.university,
                    year: !current.year
                  });
                  return;
                }
                setErrors(undefined);
                handleFormChange(current);
                setCurrent({
                  degree: '',
                  course: '',
                  specialisation: '',
                  year: 0,
                  university: ''
                });
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

function EducationItem({
  education,
  handleFormChange,
  index
}: {
  education: ITutorEducation;
  index?: number;
  handleFormChange: (v: ITutorEducation, index?: number, remove?: number) => void;
}) {
  const [errors, setErrors] = useState<EducationFormErrors>();
  useEffect(() => {
    if (!education.degree || !education.course || !education.year || !education.university) {
      setErrors({
        ...errors,
        degree: !education.degree,
        course: !education.course,
        university: !education.university,
        year: !education.year
      });
      return;
    }
  }, []);
  return (
    <div className="w-full flex items-start gap-5 border border-gray-300 p-4 rounded-md">
      <EducationForm
        degree={education.degree}
        setDegree={(value) => handleFormChange({ ...education, degree: value }, index)}
        course={education.course}
        setCourse={(value) => handleFormChange({ ...education, course: value }, index)}
        specialisation={education.specialisation}
        setSpecialisation={(value) => handleFormChange({ ...education, specialisation: value }, index)}
        university={education.university}
        setUniversity={(value) => handleFormChange({ ...education, university: value }, index)}
        year={education.year}
        setYear={(value) => handleFormChange({ ...education, year: value }, index)}
        errors={errors}
      />
      <img src={CLOSE_ICON} className="w-4 h-4 cursor-pointer" onClick={() => handleFormChange(education, index, 1)} />
    </div>
  );
}

interface EducationFormErrors {
  degree: boolean;
  course: boolean;
  university: boolean;
  year: boolean;
}
interface EducationFormProps {
  degree: string;
  setDegree: (value: string) => void;
  course: string;
  setCourse: (value: string) => void;
  specialisation: string | undefined;
  setSpecialisation: (value: string) => void;
  university: string;
  setUniversity: (value: string) => void;
  year: number;
  setYear: (value: number) => void;
  errors?: EducationFormErrors;
}

function EducationForm({
  degree,
  setDegree,
  course,
  setCourse,
  setSpecialisation,
  setUniversity,
  setYear,
  specialisation,
  university,
  year,
  errors
}: EducationFormProps) {
  return (
    <div className="w-full flex flex-col gap-7">
      <div className="flex flex-col lg:flex-row lg:items-center items-start lg:justify-between gap-2 lg:gap-0">
        <h3 className="w-full md:w-2/5 text-sm shrink-0">Select Degree</h3>
        <div className="w-full flex flex-col">
          <SelectDropDown
            onChange={(value) => {
              setDegree(value);
              // setCourse('');
            }}
            options={degreeOptions}
            placeholder="Select Degree"
            value={degree}
            isSearchable
          />
          {errors && errors?.degree && (
            <p className="text-xs font-medium text-red-400">Please Select one of the Degree</p>
          )}
        </div>
      </div>

      <div className="flex flex-col lg:flex-row lg:items-center items-start lg:justify-between gap-2 lg:gap-0">
        <h3 className="w-full md:w-2/5 text-sm shrink-0">Select Course</h3>
        <div className="w-full flex flex-col">
          <CreatableSelectDropDown
            onChange={(value) => setCourse(value as string)}
            options={courseCategories[degree] || []}
            placeholder="Select Course"
            values={course}
          />
          {errors && errors?.course && (
            <p className="text-xs font-medium text-red-400">Please Select one of the course</p>
          )}
        </div>
      </div>

      <div className="flex flex-col lg:flex-row lg:items-center items-start lg:justify-between gap-2 lg:gap-0">
        <h3 className="w-full md:w-2/5 text-sm shrink-0">Select Specialisation(optional)</h3>
        <div className="w-full flex flex-col">
          <div className="w-full">
            <input
              type="text"
              value={specialisation}
              onChange={(e) => setSpecialisation(e.target.value)}
              placeholder="Enter Your Specialisation"
              className="w-full px-4 py-3 text-sm border border-neutralBlue1 placeholder:text-grey-400 rounded-md bg-white outline-none"
            />
          </div>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row lg:items-center items-start lg:justify-between gap-2 lg:gap-0">
        <h3 className="w-full md:w-2/5 text-sm shrink-0">Enter Your University</h3>
        <div className="w-full flex flex-col">
          <CreatableSelectDropDown
            onChange={(value) => setUniversity(value as string)}
            options={UNIVERSITIES}
            placeholder="Enter Your University"
            // @ts-ignore
            values={university || undefined}
          />
          {errors && errors?.university && (
            <p className="text-xs font-medium text-red-400">Please Select one of the Univeristy</p>
          )}
        </div>
      </div>

      <div className="flex flex-col lg:flex-row lg:items-center items-start lg:justify-between gap-2 lg:gap-0">
        <h3 className="w-full md:w-2/5 text-sm shrink-0">Year Of Completion</h3>
        <div className="w-full flex flex-col">
          <SelectDropDown
            placeholder="Select Year Of Completion"
            value={year > 0 ? year.toString() : ''}
            onChange={(value) => setYear(Number(value))}
            options={years.map((i) => i.toString())}
          />
          {errors && errors?.year && (
            <p className="text-xs font-medium text-red-400">Please Select your year of completion</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default EducationDetails;
